import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import useRequest from '../../hooks/useRequest';

import MainLayout from '../../components/Layouts/MainLayout';

import ActionButton from '../../components/atoms/ActionButton';


import './styles.scss';

const NotFoundView = () => {
    const history = useHistory();

    const {
        submitted, success, message, errors,
        beforeSubmit, afterSubmit, showError,
        dealWithError
    } = useRequest();

    const login = (e) => {
        e.preventDefault();
        beforeSubmit();
        history.push('/login');
    }

    return (
        <span></span>
    );
}

export default withTranslation()(NotFoundView);